import EDIT_APPLIANCE_ESTIMATES_MODEL_FRENCH_LOCALE from "@/locales/fr/edit-appliance-estimates-modal.fr.ts";

export const EDIT_APPLIANCE_ESTIMATES_MODEL_ENGLISH_LOCALE = {
  editApplianceEstimatesModal: {
    title: "Edit site appliances declaration",
    heatPumpToQualifyInfo: "The subscriber declared a heat pump online: fill in its brand and model.",
  },
} satisfies typeof EDIT_APPLIANCE_ESTIMATES_MODEL_FRENCH_LOCALE;

export default EDIT_APPLIANCE_ESTIMATES_MODEL_ENGLISH_LOCALE;
